import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { TabBarWrapper, TabItem } from '../styled/Operations.styled'

const TABS = [
  { label: 'Operations Home', path: '/ops-control' },
  { label: 'Plan List', path: '/ops-control/plans' },
  { label: 'Dept. Board', path: '/ops-control/department' },
  { label: 'Shift Programs', path: '/ops-control/shift-programs' },
  { label: 'Triggers', path: '/ops-control/triggers' },
]

export const OperationsTabBar: React.FC = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const isActive = (path: string) => {
    if (path === '/ops-control') {
      return location.pathname === '/ops-control' || location.pathname === '/ops-control/'
    }
    return location.pathname.startsWith(path)
  }

  return (
    <TabBarWrapper>
      {TABS.map((tab) => (
        <TabItem
          key={tab.path}
          active={isActive(tab.path)}
          onClick={() => navigate(tab.path)}
        >
          {tab.label}
        </TabItem>
      ))}
    </TabBarWrapper>
  )
}
